import { gql } from 'apollo-angular';
import { AssetFragment } from '@modules/tactics/shared/graphql/fragments/asset.fragment';

export const AddAssetToActivityDocument = gql`
  mutation addAssetToActivity($input: AddAssetInputGraphql!) {
    addAssetToActivity(input: $input) {
      ...AssetFragment
    }
  }
  ${AssetFragment}
`;
